import { subscribeToMediaDock } from 'state/mediaPlaybackCoordinator'

// Remember the surface the user pressed, not just whether this song happens
// to be in the station pool. This must not open the dock or move playback.
let inlinePlay = null
let unsubscribe = null

export function clearInlineRadioPlay() {
    inlinePlay = null
    unsubscribe?.()
    unsubscribe = null
}

export function rememberInlineRadioPlay(mediaKey, meta) {
    clearInlineRadioPlay()
    const endsAt = Number(meta?.ends_at) * 1000
    if (!mediaKey || !Number.isFinite(endsAt) || endsAt <= Date.now()) return
    inlinePlay = { mediaKey, endsAt }
    unsubscribe = subscribeToMediaDock(event => {
        if (event.type === 'claim' && event.mediaKey !== mediaKey) clearInlineRadioPlay()
    })
}

export function isInlineRadioPlaying(snapshot) {
    if (!inlinePlay) return false
    if (Date.now() >= inlinePlay.endsAt) {
        clearInlineRadioPlay()
        return false
    }
    return Boolean(snapshot.isPlaying && snapshot.nowPlayingMediaKey === inlinePlay.mediaKey)
}

// Whether this key is the remembered inline station play, playing or not: its
// natural end is the station's to follow, not the playlist's.
export function isInlineRadioKey(mediaKey) {
    return Boolean(inlinePlay && mediaKey && inlinePlay.mediaKey === mediaKey)
}
